/**
 * Checks if a value is present (not null or undefined).
 *
 * @param value - The value to check.
 *
 * @example
 * isPresent(""); // true
 * isPresent("hello"); // true
 * isPresent(0); // true
 * isPresent(null); // false
 * isPresent(undefined); // false
 */
export function isPresent<TValue>(value: TValue | null | undefined): value is TValue {
	return value != null;
}
